import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY = "sunlit_admin_pwd";

export const getAdminPassword = () => localStorage.getItem(ADMIN_KEY) || "";
export const setAdminPassword = (pwd) => localStorage.setItem(ADMIN_KEY, pwd);
export const clearAdminPassword = () => localStorage.removeItem(ADMIN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const pwd = getAdminPassword();
  if (pwd) {
    config.headers["X-Admin-Password"] = pwd;
  }
  return config;
});
